import React from 'react'

type DocumentLinkProps = {
  name: string
  urlDoc: string
  urlPdf: string
  sizeDoc?: string
  sizePdf?: string
}
type DocumentLinkState = null
class DocumentLink extends React.Component<
  DocumentLinkProps,
  DocumentLinkState
> {
  render() {
    const {} = this.props
    return (
      <span className="file-info">
        <a
          href={this.props.urlDoc}
          className="resource-link"
          target="_blank"
          aria-label={this.props.name + ' in DOC format'}
          rel="noreferrer"
        >
          {this.props.name} (DOC{this.props.sizeDoc})&nbsp;
        </a>
        <a
          href={this.props.urlPdf}
          className="resource-link"
          target="_blank"
          aria-label={this.props.name + ' in PDF format'}
          rel="noreferrer"
        >
          (PDF{this.props.sizePdf})
        </a>
      </span>
    )
  }
}

export default DocumentLink
